(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fostr-carousel-component"] && !Shopify.designMode) return;
  try {
    
    class FostrCarouselComponent extends HTMLElement {
        constructor() {
            super();
            this.slider = this.querySelector('fostr-slider-component');

            this.controls = this.querySelector('fostr-carousel-controls-component');
        }

        currentSlideUpdated(index) {
            if(this.controls) {
                this.controls.currentSlideUpdated(index);
            }
        }
    }

    class FostrCarouselControlsComponent extends HTMLElement {
        currentSlideIndex = 0;
        constructor() {
            super();
            this.initialiseSlideIndicators();
            this.initialiseButtons();
        }

        initialiseButtons() {
            let nextButton = document.createElement('slide-button');
            nextButton.setAttribute("data-next", true);
            nextButton.setAttribute("aria-label", "Next slide");
            nextButton.onclick = () => {
                let numberOfSlides = this.parentElement.slider.slides.length;
                let slide = this.currentSlideIndex + 1;
                let next = this.currentSlideIndex + 1;
                if(slide >= numberOfSlides) {
                    next = 0;
                }
                this.goToSlide(next);
            }
            nextButton.innerHTML = "Next Slide";

            let previousButton = document.createElement('slide-button');
            previousButton.setAttribute("data-next", false);
            previousButton.setAttribute("aria-label", "Previous slide");
            previousButton.onclick = () => {
                let numberOfSlides = this.parentElement.slider.slides.length;
                let slide = this.currentSlideIndex + 1;
                let previous = this.currentSlideIndex - 1;
                if(slide == 1) {
                    previous = numberOfSlides - 1;
                }
                this.goToSlide(previous);
            }
            previousButton.innerHTML = "Previous Slide";

            this.appendChild(previousButton);
            this.appendChild(nextButton);
        }

        initialiseSlideIndicators() {
            this.parentElement.slider.slides.forEach((slide, index) => {
                this.addSlideIndicator(index);
            });
        }

        addSlideIndicator(index) {
            let indicator = document.createElement('slide-indicator');
            indicator.setAttribute("data-index", index);
            if(index == 0) {
                indicator.setAttribute("data-current", '');
            }
            indicator.onclick = () => this.goToSlide(index);
            this.appendChild(indicator);
        }

        currentSlideUpdated(slideIndex) {
            this.currentSlideIndex = parseInt(slideIndex);
            let indicators = this.querySelectorAll('slide-indicator');
            indicators.forEach((indicator, index) => {
                if(slideIndex == index) {
                    indicator.setAttribute("data-current", '');
                } else {
                    indicator.removeAttribute("data-current");
                }
            })
        }

        goToSlide(index) {
            this.parentElement.slider.scrollToSlideByIndex(index);
        }
    }

    class FostrSliderComponent extends HTMLElement {
        beingClicked = false;
        last_changed_frame = 0;
        scrollingLeft = false;
        hasScrolled = false;
        controller = new AbortController();
        lastXCoordinate;
        currentSlide;

        constructor() {
            super();
            this.slides = this.querySelectorAll('fostr-slide-component');
            this.currentSlide = this.slides.item(0);
            this.currentSlide.current = true;
            if(this.supportsSmoothScrolling()) {
                this.setupEventListeners();
            } else {
                this.setupNoSmoothScroll();
            }
        }

        setupNoSmoothScroll() {
            this.style.scrollSnapType = 'x mandatory';
            this.style.webkitOverflowScrolling = 'touch';
            this.style.webkitScrollSnapType = 'x mandatory';

            this.slides.forEach(slide => {
                slide.style.scrollSnapAlign = 'center';
            });

            this.addEventListener('mousedown', event => this.mouseDownEvent(event), true);
            this.addEventListener('mouseup', event => this.mouseUpEvent(event), true);
            this.addEventListener('mousemove', event => this.mouseMoveEvent(event), true);
            this.addEventListener('mouseleave', event => this.mouseLeaveEvent(event), true);
        }

        setupEventListeners() {
            this.addEventListener('mousedown', event => this.mouseDownEvent(event), true);
            this.addEventListener('mouseup', event => this.mouseUpEvent(event), true);
            this.addEventListener('mousemove', event => this.mouseMoveEvent(event), true);
            this.addEventListener('mouseleave', event => this.mouseLeaveEvent(event), true);
            this.addEventListener("scroll", event => this.scrollEvent(event), { signal: this.controller.signal });
        }

        scrollEvent(event) {
            this.controller.abort();
            this.controller = new AbortController();
            this.hasScrolled = false;
            this.waitForScrollEnd().then(() => this.scrollToCurrentSlide());
        }

        supportsSmoothScrolling() {
            const body = document.body;
            const scrollSave = body.style.scrollBehavior;
            body.style.scrollBehavior = 'smooth';
            const hasSmooth = getComputedStyle(body).scrollBehavior === 'smooth';
            body.style.scrollBehavior = scrollSave;
            return hasSmooth;
        }

        waitForScrollEnd() {
            return new Promise( (resolve) => {
                this.tick(0, this, resolve);
            });
        }

        tick(frames, component, resolve) {
            if (frames - component.last_changed_frame >= 10) {
                resolve();
            } else {
                if (component.scrollLeft != component.lastXCoordinate) {
                    component.hasScrolled = true;
                    if(component.scrollLeft < component.lastXCoordinate) {
                        component.scrollingLeft = true;
                    } else {
                        component.scrollingLeft = false;
                    }
                    component.last_changed_frame = frames;
                    component.lastXCoordinate = component.scrollLeft;
                }
                requestAnimationFrame(component.tick.bind(null, frames + 1, component, resolve));
            }
        }

        mouseDownEvent(event) {
            this.beingClicked = true;
            this.style.cursor = "grab";
            if(!this.supportsSmoothScrolling()) {
                this.style.scrollSnapType = 'none';
                this.style.webkitOverflowScrolling = 'none';
                this.style.webkitScrollSnapType = 'none';
            }


            event.preventDefault();
        }

        mouseUpEvent(event) {
            this.beingClicked = false;
            this.style.cursor = "";
            if(!this.supportsSmoothScrolling()) {
                this.style.scrollSnapType = 'x mandatory';
                this.style.webkitOverflowScrolling = 'touch';
                this.style.webkitScrollSnapType = 'x mandatory';
            }
        }

        mouseMoveEvent(event) {
            if(this.beingClicked) {
                this.scrollLeft -= event.movementX;
            }
        }

        mouseLeaveEvent(event) {
            if(!this.supportsSmoothScrolling()) {
                this.style.scrollSnapType = 'x mandatory';
                this.style.webkitOverflowScrolling = 'touch';
                this.style.webkitScrollSnapType = 'x mandatory';
            }
            this.beingClicked = false;
        }

        scrollToCurrentSlide() {
            if(this.hasScrolled) {
                this.getSlideToScrollTo();
                let computedPadding = parseInt(window.getComputedStyle(this, null).getPropertyValue('padding-left'));
                this.scroll({
                    top: 0,
                    left: this.currentSlide.offsetLeft - computedPadding,
                    behavior: 'smooth'
                });
                this.parentElement.currentSlideUpdated(this.currentSlide.getAttribute('data-index'));
                this.addEventListener("scroll", event => this.scrollEvent(event), { signal: this.controller.signal });
            }
        }

        scrollToSlideByIndex(index) {
            let computedPadding = parseInt(window.getComputedStyle(this, null).getPropertyValue('padding-left'));
            this.scroll({
                top: 0,
                left: this.slides[index].offsetLeft - computedPadding,
                behavior: 'smooth'
            });
            this.parentElement.currentSlideUpdated(this.currentSlide.getAttribute('data-index'));
        }

        getSlideToScrollTo() {
            let slideFound = false;
            let indexFound;
            this.slides.forEach((slide, index) => {
                slide.current = false;
                if(this.scrollingLeft) {
                    if((slide.offsetLeft + (slide.clientWidth * .75)) >= this.scrollLeft && !slideFound) {
                        this.currentSlide = slide;
                        slideFound = true;
                        slide.current = true;
                        indexFound = index;
                    }
                } else {
                    if((slide.offsetLeft + (slide.clientWidth / 4)) > this.scrollLeft && !slideFound) {
                        this.currentSlide = this.slides[index];
                        slideFound = true;
                        slide.current = true;
                        indexFound = index;
                    }
                }
            });
        }
    }

    class FostrSlideComponent extends HTMLElement {
        current = false;
        index;
        constructor() {
            super();
        }
    }


    customElements.define('fostr-carousel-component', FostrCarouselComponent);
    customElements.define('fostr-slider-component', FostrSliderComponent);
    customElements.define('fostr-slide-component', FostrSlideComponent);
    customElements.define('fostr-carousel-controls-component', FostrCarouselControlsComponent);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fostr-footer"]) return;
  try {
    

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

customElements.define('localization-form', LocalizationForm);


const isError = document.querySelector('.footer-email-input');

function addMultipleEventListener(element, events, handler) {
  events.forEach(e => element.addEventListener(e, handler))
}

function showButton(){
   const buttonVisibility = document.querySelector('.newsletter-form__button');
    let check = isError.checkValidity()
    buttonVisibility.style.visibility = 'hidden';
    if(check === true){
      buttonVisibility.style.visibility = 'visible';
    }
}

  addMultipleEventListener(isError, ['keypress', 'change'], showButton);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fostr-legal-popup"] && !Shopify.designMode) return;
  try {
    

class ModalDialogLegal extends HTMLElement {
  constructor() {
    super();
    this.popup_id = document.querySelector('#PopupModal-fostr-legal');
    console.log(this.popup_id)
    this.button = this.popup_id.querySelector('#legal_accept');
    this.button.addEventListener('click', this.clickAction.bind(this))
    this.getLocalId = localStorage.getItem('{{section.settings.local_id}}')
    this.showPopup()
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }

  clickAction() {
    localStorage.setItem('{{section.settings.local_id}}', 'true');
    document.querySelector('body').classList.remove('overflow-hidden')
    this.popup_id.removeAttribute('open');
  }

  showPopup(){
        console.log(this.popup_id, 'function')

    if (this.getLocalId !== 'true') {
    this.popup_id.setAttribute('open', true);
    document.querySelector('body').classList.add('overflow-hidden')
}

  }

}
customElements.define('modal-dialog-legal', ModalDialogLegal);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fostr-main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fostr-main-product-giftcard"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fostr-mini-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fostr-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-appointment-widget"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
